/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getDashboardCacheKey('slideDeck', { slideDeckPublicKey })`.
 */
export const seriesCacheKey = (seriesId: string) =>
  `coreUrl/series/${seriesId}`;

type SlideDeckCacheKey = ({
  slideDeckPublicKey,
}: {
  slideDeckPublicKey: string;
}) => string;

export interface TotalParticipantCountCacheKey {
  url: string;
  slideDeckPublicKey: string;
}

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getDashboardCacheKey('slideDeck', { slideDeckPublicKey })`.
 */
export const slideDeckCacheKey: SlideDeckCacheKey = ({ slideDeckPublicKey }) =>
  seriesCacheKey(slideDeckPublicKey);

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getDashboardCacheKey('slides', { slideDeckPublicKey })`.
 */
export const questionsCacheKey = (seriesId: string) =>
  `coreUrl/series/${seriesId}/questions`;

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getDashboardCacheKey('results', { slideAdminKey, session })`.
 */
export const resultCacheKey = (
  questionId: string,
  session: number | 'current' = 'current',
) => {
  return `coreUrl/questions/${questionId}/result/session/${session}`;
};

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getEditorSWRCacheKey('quizPlayersScore', { slideAdminKey })`.
 */
export const quizPlayersScoreCacheKey = (questionId: string) =>
  `coreUrl/questions/${questionId}/quiz-players`;

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getEditorSWRCacheKey('quizResult', { questionId })`.
 */
export const quizResultCacheKey = (questionId: string) =>
  `coreUrl/questions/${questionId}/quiz-result`;

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getPresentationCacheKey('reactionResults', { slideAdminKey })`.
 */
export const reactionsResultsCacheKey = (questionId: string) =>
  `coreUrl/presentation/reactions/${questionId}/results`;

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getEditorSWRCacheKey('seriesSessions', { slideDeckPublicKey })`.
 */
export const seriesSessionsCacheKey: SlideDeckCacheKey = ({
  slideDeckPublicKey,
}) => `coreUrl/series/${slideDeckPublicKey}/sessions`;

/**
 * @deprecated Use a domain-specific cache key instead.
 * @example `getPresentationCacheKey('questionSessions', { slideAdminKey })`.
 */
export const questionSessionsCacheKey = (questionId: string) =>
  `coreUrl/questions/${questionId}/sessions`;

/**
 * Function generating the cache key for useSeriesHasResults used to invalidate cache correctly
 * @param {string} slideDeckPublicKey - The series id.
 * @param {number} minRespondents - The minimum respondents required.
 */
export const seriesHasResultsCacheKey = ({
  slideDeckPublicKey,
  minRespondents,
}: {
  slideDeckPublicKey: string;
  minRespondents?: number | undefined;
}) => {
  const queryParam = minRespondents ? `min_respondents=${minRespondents}` : '';
  return `/series/${slideDeckPublicKey}/has-results&${queryParam}`;
};

export const getFetchResultsCacheKey = (
  adminKey: string,
  sessionId?: number | 'current',
) => {
  const baseKey = `/presentation/questions/${adminKey}/results`;
  const sessionKey = sessionId ? `/session/${sessionId}` : '';
  return `${baseKey}${sessionKey}`;
};

export const getTotalParticipantCountCacheKey = ({
  slideDeckPublicKey,
}: {
  slideDeckPublicKey: string;
}): TotalParticipantCountCacheKey => ({
  url: `/results/series/${slideDeckPublicKey}/total-participant-count`,
  slideDeckPublicKey,
});
